import { Box } from 'grommet'
import styled from 'styled-components'

import { NormalizedWrapper } from '@theme'

const BLOCK_MAX_WIDTH = 175
const BLOCK_MIN_HEIGHT = 264

export const Wrapper = styled(Box)`
  margin-top: ${({ theme }) => theme.spaces[5] + theme.spaces[3]}px;
  position: relative;

  ${({ theme }) => theme.below.tablet`
    .description-subtitle {
      font-size: ${theme.typography.mobile.title.title4.fontSize}px;
      line-height: ${theme.typography.mobile.title.title4.lineHeight}px;
    }
  `}
`

export const WideTechStackWrapper = styled(NormalizedWrapper)`
  margin: ${({ theme }) => theme.spaces[0]} auto;
  width: 100%;

  .items-container {
    justify-content: space-around;
    margin-bottom: ${({ theme }) => theme.spaces[6]}px;

    ${({ theme }) => theme.below.tablet`
      margin-bottom: ${theme.spaces[5]}px;
      gap: ${theme.newSpaces.xs}px;
      justify-content: center;
    `}
  }

  .block {
    display: flex;
    align-content: flex-start;
    align-items: center;
    background: ${({ theme }) => theme.colors.backLight};
    border: none;
    border-radius: unset;
    flex-direction: column;
    justify-content: flex-start;
    margin: ${({ theme }) => theme.spaces[0]};
    max-width: 280px;
    min-height: 380px;
    padding: ${({ theme }) => theme.spaces[3]}px;
    text-align: center;
    ${({ theme }) => theme.below.laptopL`
    margin: 0 auto ${theme.spaces[4]}px auto;
    `}

    ${({ theme }) => theme.below.tablet`
      margin: 0px;
      max-width: ${BLOCK_MAX_WIDTH}px;
      width: 100%;
      min-height: ${BLOCK_MIN_HEIGHT}px;
      padding: 0px;
  `}
  }

  .block:hover {
    background: ${({ theme }) => theme.colors.gradientLightGray};

    .block-title {
      color: unset;
    }
    .block-text {
      color: ${({ theme }) => theme.colors.silver};
    }
  }

  .image-container {
    margin: 0 auto ${({ theme }) => theme.spaces[4]}px;
    position: relative;
    ${({ theme }) => theme.below.tablet`
      margin-bottom: ${theme.newSpaces.xs}px;
      transform: scale(0.80);
      & > svg {
        margin: 0px;
      }
  `}
  }

  .block-title {
    font-weight: ${({ theme }) => theme.fontWeight[6]};

    ${({ theme }) => theme.below.laptopL`
      margin-top: ${theme.spaces[0]}px;
    `}

    ${({ theme }) => theme.below.tablet`
      text-transform: uppercase;
      margin: 0px;
      line-height: ${theme.typography.mobile.title.title3.lineHeight}px;
      font-size: ${theme.typography.mobile.title.title3.fontSize}px;
  `}
  }

  .block-text {
    padding: ${({ theme }) => theme.spaces[2] + 3}px;
    padding-top: ${({ theme }) => theme.spaces[3]}px;

    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.typography.mobile.body.body3.fontSize}px;
      line-height: ${theme.typography.mobile.body.body3.lineHeight}px;
      text-align: center;
    `}
  }
`
